import React from 'react'
import ThreeColumnLayout from '~layouts/ThreeColumnLayout'

import style from './Centered.module.scss'

const Centered = ({
  children,
  wide
}) => {
  let alignment = ['', true].includes(wide) ? 'wide' : 'narrow'
  
  return (
    <div className={style.centered}>
      <ThreeColumnLayout alignment={ alignment }>
        <></>
        <>{ children }</>
        <></>
      </ThreeColumnLayout>
    </div>
  )
}

export default Centered